"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var HandleRequest_1 = require("../../../../../common/js/services/requestHttp/HandleRequest");
var loadGoogleMapsApi = require("load-google-maps-api");
var StoreLocatore = /** @class */ (function (_super) {
    __extends(StoreLocatore, _super);
    function StoreLocatore($view) {
        var _this = _super.call(this, $view) || this;
        _this.$mapPreview = _this.$view.find("#map");
        _this.key = _this.$mapPreview.data("key");
        _this.lat = 47.21498227780353;
        _this.lng = -1.6065176003278498;
        _this.findMyLocation = _this.$view.find('#bFindMyPosition');
        _this.findByInput = _this.$view.find('#tSearchLocation');
        _this.bSearch = _this.$view.find('#bSearch');
        _this.bind();
        _this.getStore(null, null, false);
        _this.findByInput.on('keyup', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                _this.getStore(_this.findByInput.val(), null, true);
            }
        });
        _this.bSearch.on('click', function (e) {
            _this.getStore(_this.findByInput.val(), null, true);
        });
        _this.findMyLocation.on('click', function () {
            if (navigator.permissions && navigator.permissions.query) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    //@ts-ignore
                    _this.markCustomerPosition = new google.maps.Marker({
                        //@ts-ignore
                        position: pos, map: _this.map, icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 0
                        }
                    });
                    //this.infowindow.setPosition(pos);
                    //this.infowindow.setContent("Location found.");
                    _this.infowindow.open(_this.map);
                    //@ts-ignore
                    _this.map.setCenter(pos);
                    //@ts-ignore
                    _this.map.setZoom(12);
                    _this.getStore(null, pos, true);
                }, function () {
                    //@ts-ignore
                    _this.handleLocationError(true, _this.infowindow, _this.map.getCenter());
                });
            }
            else {
                // Browser doesn't support Geolocation
                //@ts-ignore
                _this.handleLocationError(false, _this.infowindow, _this.map.getCenter());
            }
        });
        return _this;
    }
    StoreLocatore.prototype.getStore = function (zip, posCustomer, search) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response, data, i, city, zip_1, address, telephone, distance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        if (posCustomer != null) {
                            formData.append("lng", posCustomer.lng);
                            formData.append("lat", posCustomer.lat);
                        }
                        if (zip != null) {
                            formData.append("zip", zip);
                        }
                        return [4 /*yield*/, (0, HandleRequest_1.send)($('#routeGetStore').val().toString(), 'POST', formData)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        $(".results").empty();
                        for (i = 0; i < data.shops.length; i++) {
                            city = "";
                            if (data.shops[i]["city"] != "") {
                                city = " " + data.shops[i]["city"];
                            }
                            zip_1 = "";
                            if (data.shops[i]["zip"] != "") {
                                zip_1 = "<br/>" + data.shops[i]["zip"];
                            }
                            address = data.shops[i]["address"];
                            if (data.shops[i]["additional_1"] != "" && data.shops[i]["additional_1"] != null) {
                                address += "<br/>" + data.shops[i]["additional_1"];
                            }
                            if (data.shops[i]["additional_2"] != "" && data.shops[i]["additional_2"] != null) {
                                address += "<br/>" + data.shops[i]["additional_2"];
                            }
                            address += zip_1 + city;
                            this.codeAddress(this.geocoder, this.map, address, (i == 0) ? true : false, search);
                            telephone = "";
                            if (data.shops[i]['phone'] != null && data.shops[i]['phone'] != "") {
                                telephone = " <br/><br/> Tél : " + data.shops[i]['phone'];
                            }
                            distance = "";
                            if (data.shops[i]['distance'] != 0) {
                                distance = data.shops[i]['distance'].toFixed(1) + ' km';
                            }
                            $(".results").append('' +
                                '<div class="item text-white position-relative">\n' +
                                '                                        <div class="title d-flex justify-content-between mb-2">\n' +
                                '\t\t\t\t\t\t\t\t\t\t<span>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t<svg width="24" height="24" viewBox="0 0 24 24" fill="none"\n' +
                                '                                                 xmlns="http://www.w3.org/2000/svg">\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t<g clip-path="url(#clip0_1811_2283)">\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t<path d="M12 20.8999L16.95 15.9499C17.9289 14.9709 18.5955 13.7236 18.8656 12.3658C19.1356 11.0079 18.9969 9.60052 18.4671 8.32148C17.9373 7.04244 17.04 5.94923 15.8889 5.18009C14.7378 4.41095 13.3844 4.00043 12 4.00043C10.6156 4.00043 9.26222 4.41095 8.11109 5.18009C6.95996 5.94923 6.06275 7.04244 5.53292 8.32148C5.00308 9.60052 4.86442 11.0079 5.13445 12.3658C5.40449 13.7236 6.07111 14.9709 7.05 15.9499L12 20.8999ZM12 23.7279L5.636 17.3639C4.37734 16.1052 3.52019 14.5016 3.17293 12.7558C2.82567 11.0099 3.00391 9.20035 3.6851 7.55582C4.36629 5.91129 5.51984 4.50569 6.99988 3.51677C8.47992 2.52784 10.22 2 12 2C13.78 2 15.5201 2.52784 17.0001 3.51677C18.4802 4.50569 19.6337 5.91129 20.3149 7.55582C20.9961 9.20035 21.1743 11.0099 20.8271 12.7558C20.4798 14.5016 19.6227 16.1052 18.364 17.3639L12 23.7279ZM12 12.9999C12.5304 12.9999 13.0391 12.7892 13.4142 12.4141C13.7893 12.0391 14 11.5304 14 10.9999C14 10.4695 13.7893 9.96078 13.4142 9.58571C13.0391 9.21064 12.5304 8.99992 12 8.99992C11.4696 8.99992 10.9609 9.21064 10.5858 9.58571C10.2107 9.96078 10 10.4695 10 10.9999C10 11.5304 10.2107 12.0391 10.5858 12.4141C10.9609 12.7892 11.4696 12.9999 12 12.9999ZM12 14.9999C10.9391 14.9999 9.92172 14.5785 9.17158 13.8283C8.42143 13.0782 8 12.0608 8 10.9999C8 9.93906 8.42143 8.92164 9.17158 8.17149C9.92172 7.42135 10.9391 6.99992 12 6.99992C13.0609 6.99992 14.0783 7.42135 14.8284 8.17149C15.5786 8.92164 16 9.93906 16 10.9999C16 12.0608 15.5786 13.0782 14.8284 13.8283C14.0783 14.5785 13.0609 14.9999 12 14.9999Z"\n' +
                                '                                                      fill="white"/>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t</g>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t<defs>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t<clipPath id="clip0_1811_2283">\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t<rect width="24" height="24" fill="white"/>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t</clipPath>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t\t</defs>\n' +
                                '\t\t\t\t\t\t\t\t\t\t\t</svg>\n' +
                                data.shops[i]["name"] +
                                '\t\t\t\t\t\t\t\t\t\t</span>\n' +
                                '                                            <span class="dist fw-lighter fs-5 distance' + data.shops[i]['id'] + '">\n ' + distance +
                                '\t\t\t\t\t\t\t\t\t\t</span>\n' +
                                '                                        </div>\n' +
                                '                                            <div class="address fs-5 fw-lighter">\n' +
                                address + telephone + '<br/>\n' +
                                '                                            </div>\n' +
                                '\n' +
                                '                                        <a href="' + data.shops[i]['link'] + '" class="stretched-link"><span>Voir<span></a>\n' +
                                '                                    </div>');
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreLocatore.prototype.codeAddress = function (geocoder, map, address, first, search) {
        // tslint:disable-next-line:only-arrow-functions
        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status === 'OK') {
                //map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
                if (first && search) {
                    map.setCenter(results[0].geometry.location);
                    map.setZoom(12);
                }
            }
            else {
                //alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    };
    StoreLocatore.prototype.handleLocationError = function (browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(browserHasGeolocation
            ? "Error: The Geolocation service failed."
            : "Error: Your browser doesn't support geolocation.");
    };
    StoreLocatore.prototype.bind = function () {
        var _this = this;
        loadGoogleMapsApi({ key: this.key })
            .then(function (googleMaps) {
            // Carte
            _this.map = new googleMaps.Map(_this.$mapPreview[0], {
                center: { lat: _this.lat, lng: _this.lng },
                zoom: 9,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        elementType: "geometry",
                        stylers: [{ color: "#f5f5f5" }],
                    },
                    {
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#616161" }],
                    },
                    {
                        elementType: "labels.text.stroke",
                        stylers: [{ color: "#f5f5f5" }],
                    },
                    {
                        featureType: "administrative.land_parcel",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#bdbdbd" }],
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [{ color: "#eeeeee" }],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#757575" }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [{ color: "#e5e5e5" }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#9e9e9e" }],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [{ color: "#ffffff" }],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#757575" }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [{ color: "#dadada" }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#616161" }],
                    },
                    {
                        featureType: "road.local",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#9e9e9e" }],
                    },
                    {
                        featureType: "transit.line",
                        elementType: "geometry",
                        stylers: [{ color: "#e5e5e5" }],
                    },
                    {
                        featureType: "transit.station",
                        elementType: "geometry",
                        stylers: [{ color: "#eeeeee" }],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{ color: "#c9c9c9" }],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#9e9e9e" }],
                    },
                ],
            });
            _this.geocoder = new google.maps.Geocoder();
            // Icon
            _this.markerIcon = {
                url: "/images/map-marker.png",
                scaledSize: new google.maps.Size(27, 36),
            };
            _this.infowindow = new google.maps.InfoWindow();
        })
            .catch(function (error) {
            console.error(error);
        });
        //this.refetchMarkers([{"location": {lat: this.lat, lng: this.lng}}]);
    };
    StoreLocatore.prototype.haversine_distance = function (mk1, mk2) {
        var R = 6371; // Radius of the Earth in km
        var rlat1 = mk1.position.lat() * (Math.PI / 180); // Convert degrees to radians
        var rlat2 = mk2.position.lat() * (Math.PI / 180); // Convert degrees to radians
        var difflat = rlat2 - rlat1; // Radian difference (latitudes)
        var difflon = (mk2.position.lng() - mk1.position.lng()) * (Math.PI / 180); // Radian difference (longitudes)
        var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
        return d;
    };
    StoreLocatore.prototype.refetchMarkers = function (feed) {
        if (Array.isArray(feed)) {
            this.deleteMarkers();
            for (var _i = 0, feed_1 = feed; _i < feed_1.length; _i++) {
                var element = feed_1[_i];
                this.addMarker(element);
            }
            this.showMarkers();
        }
    };
    StoreLocatore.prototype.deleteMarkers = function () {
        this.map = null;
        this.setMapOnMarkers();
        this.markers = [];
    };
    StoreLocatore.prototype.setMapOnMarkers = function () {
        console.log(this.markers);
        console.log("-----------");
        if (this.markers != null) {
            for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
                var marker = _a[_i];
                marker.setMap(this.map);
            }
        }
    };
    StoreLocatore.prototype.showMarkers = function () {
        this.setMapOnMarkers();
    };
    StoreLocatore.prototype.addMarker = function (markerData) {
        var marker = new google.maps.Marker({
            position: markerData.location,
            icon: this.markerIcon,
        });
        this.markers.push(marker);
    };
    return StoreLocatore;
}(BaseComponent_1.default));
exports.default = StoreLocatore;
